<template>
  <v-container fluid>
    <router-view
      :contract="contract"
      :reports="reports"
      @FETCH_DATA="handleFetchData()"
    />
  </v-container>
</template>

<script>
import { getUser, getReports } from '@/services'

export default {
  name: 'ReportsMain',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      reports: []
    }
  },
  computed: { },
  async mounted () {
    this.setRoute()
    await this.handleFetchData()
  },
  updated () {
    this.setRoute()
  },
  methods: {
    async handleFetchData (contractId = this.$route.params.contractId) {
      const reports = await getReports(contractId)
      const items = []
      for (const report of reports) {
        const user = await getUser(report.report.createdBy)
        report.user = user.displayName
        items.push(report)
      }
      this.reports = items
    },
    setRoute () {
      this.$route.name === 'reportsMain' && this.$router.replace({ name: 'reports' })
    }
  },
  watch: { }
}
</script>
